export const getSeletedRoutes = function (routeList) {
  return routeList.filter((el) => {
    if (el.isSelected) {
      if (el.permissionChild && el.permissionChild.length) {
        el.permissionChild = getSeletedRoutes(el.permissionChild);
      }
      return el;
    }
  });
};

const stringRouteArr = [];

const stringButtnsArr = []

const getStringRouteArr = function (list) {
  list.forEach((el) => {
    if (el.permissionType != 2) {
      stringRouteArr.push(el.permissionName);
      if (el.permissionChild && el.permissionChild.length) {
        getStringRouteArr(el.permissionChild);
      }
    }else{
      stringButtnsArr.push(el.permissionId)
    }
  });
};

const filterRoutes = function (stringRouteArr, children) {
    return children.filter((el)=>{
        if (stringRouteArr.includes(el.meta.title)) {
            if (el.children && el.children.length) {
             el =  filterRoutes(stringRouteArr,el.children)
            }
            return el
        }
    })

};

export const filterDynamicRoutes = function (selectedrouteList, DynamicRoutes) {
  getStringRouteArr(selectedrouteList);
  const filterRoutesList =  filterRoutes(stringRouteArr , DynamicRoutes[0].children);
   return {
    filterRoutesList,
    stringButtnsArr
   }
};
